import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, filter, takeUntil } from 'rxjs';
import { DialogService } from '../../services/dialog.service';
import { DefaultValuesService } from '../../services/defaultvalues.service';
import { SaveService } from '../../services/save.service';
import { Utils } from '../../utils/utils';
import { NavigationEnd, Router } from '@angular/router';
import { MersyMassReleaseRevokeDto } from '../../interfaces/mersymassreleaserevokedto';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'period',
    standalone: true,
    imports: [NgSelectModule, FormsModule, MatTooltipModule],
    template: `Period:<br />
                @if (!isMassReleaseRevoke()) {
                  <ng-select
                    (change)="onSelect($event)" style="width:180px; border: 1px white solid" class="top-main-select"
                    [items]="filteredPeriod"
                    bindLabel="label"
                    bindValue="id"
                    [closeOnSelect]="true"
                    [searchable]="true"
                    [(ngModel)]="defaults.period">
                  </ng-select>
                }
                @if (isMassReleaseRevoke()) {
                  <ng-select
                    (change)="onSelect($event)" style="width:180px; border: 1px white solid" class="top-main-select"
                    [items]="filteredPeriod"
                    [disabled]="isOPL()"
                    bindLabel="label"
                    bindValue="id"
                    [matTooltip]="toolTipText()"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [(ngModel)]="this.selectedValues"
                    [searchable]="true">
                    <ng-template ng-option-tmp
                      let-item="item">
                      {{ item.label }}
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      @if (selectedValues.length <= 1) {
                        <div class="items-selected">
                          @for (item of selectedValues; track item) {
                            <div class="ng-value">
                              <span class="ng-value-label">{{getLabelFromId(item)}}</span>
                            </div>
                          }
                        </div>
                      }
                      @if (items.length > 1) {
                        <div class="ng-value">
                          <span class="ng-value-label">{{items.length}} Selected...</span>
                        </div>
                      }
                    </ng-template>
                  </ng-select>
                }`,
})

export class PeriodComponent implements OnInit {
    @Input() selBehaviour: string = 'Default';
    @Input() relrevokeParamsIn: MersyMassReleaseRevokeDto = {} as MersyMassReleaseRevokeDto;

    @Output() relrevokeParams = new EventEmitter<MersyMassReleaseRevokeDto>();
    public mersyMassRelRevParams: MersyMassReleaseRevokeDto = {} as MersyMassReleaseRevokeDto 
    public selectedValues: any[]= []

    list: any[] = [{ 'id': 1, 'label': 'Period 1 (10-{{year}})' },
    { 'id': 2, 'label': 'Period 2 (11-{{year}})' },
    { 'id': 3, 'label': 'Period 3 (12-{{year}})' },
    { 'id': 4, 'label': 'Period 4 (01-{{year}})' },
    { 'id': 5, 'label': 'Period 5 (02-{{year}})' },
    { 'id': 6, 'label': 'Period 6 (03-{{year}})' },
    { 'id': 7, 'label': 'Period 7 (04-{{year}})' },
    { 'id': 8, 'label': 'Period 8 (05-{{year}})' },
    { 'id': 9, 'label': 'Period 9 (06-{{year}})' },
    { 'id': 10, 'label': 'Period 10 (07-{{year}})' },
    { 'id': 11, 'label': 'Period 11 (08-{{year}})' },
    { 'id': 12, 'label': 'Period 12 (09-{{year}})' }
    ];

    value: number = 0;

    public filteredPeriod: any[] = [];

    protected _onDestroy = new Subject<void>();

    actualReportingLinks = [
        "/actualreporting",
        "/actualbranchreporting",
        "/pequarterreporting"
    ]
    previousActualReportingP1Rel: boolean | null = null;
    isActualReprtingP1Rel: boolean | null = null;

    private readonly now: Date;
    private readonly month: number;
    private readonly isPeriod1: boolean;
    private initialPeriod: number = -1;

    constructor(
        private readonly http: HttpClient
        , @Inject('BASE_URL') private readonly baseUrl: string
        , public defaults: DefaultValuesService
        , private readonly dialog: DialogService
        , public saveService: SaveService
        , private readonly router: Router
    ) {
        this.now = new Date();
        this.month = this.now.getMonth();
        this.isPeriod1 = this.month == 9;
    }

    async ngOnInit(): Promise<void> {

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this._onDestroy)
        ).subscribe(async (event: any) => {
            await this.onInitAbstr(event.url);
        });

        this.defaults.fiscalYearMessageChanges$
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.reloadFilteredPeriod();
            });

        this.defaults.languageMessageChanges$
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.reloadFilteredPeriod();
                this.initialPeriod = this.defaults.period;
            });
    }

    async onInitAbstr(url = "") {
        this.isActualReprtingP1Rel = this.isPeriod1 && this.actualReportingLinks.includes(url);
        const changePeriodTrigger = this.shouldChangePeriod();
        if (changePeriodTrigger) {
            this.previousActualReportingP1Rel = this.isActualReprtingP1Rel;
            this.autoSetPeriodValue();
        } 
    }
    autoSetPeriodValue() {
        if (this.isActualReprtingP1Rel) {
            this.defaults.period = 12;
        } else {
            this.defaults.period = this.initialPeriod;
        }
        this.value = this.defaults.period;
        this.onNo();
    }
    shouldChangePeriod() {
        return this.previousActualReportingP1Rel !== this.isActualReprtingP1Rel
    }

    ngOnDestroy(): void {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
    changeFiscalYear() {
        this.sendPost();
    }

    onNo() {
        this.saveService.fireCancelAll();
        this.changeFiscalYear();
    }

    onSelect(l: any) {
        if (!l)
            return;

        if (this.isMassReleaseRevoke()) {
            this.mersyMassRelRevParams.Periods = this.selectedValues;
            this.relrevokeParams.emit(this.mersyMassRelRevParams)
            return
        }
        this.value = l.id;
        if (this.saveService.isSaveButtonShown())
            this.dialog.showConfirmDialog("Do you want to save the changes? If you select No, all changes will be lost!", "Save", this);
        else
            this.onNo();

    }

    reloadFilteredPeriod() {
        this.filteredPeriod = this.list.map(x => {
            return {
                'id': x.id,
                'label': x.label.replaceAll('{{year}}',
                    x.id === 1 || x.id === 2 || x.id === 3 ?
                        (this.defaults.fiscalYear ?? 0) - 1 : this.defaults.fiscalYear)
            }
        });
    }

    onYes() {
        this.saveService.fireSave();
        this.changeFiscalYear();
    }

    sendPost() {
        let tthis = this;
        this.defaults.period = this.value;
        this.http
            .post<number>(this.baseUrl + Utils.getPeriodAPI(), this.defaults.period)
            .subscribe(() => {
                this.defaults.notifyPeriodChange();
            }, error => Utils.writeLog(tthis.http, tthis.baseUrl, error)); //error => console.log(error));
    }

    public isMassReleaseRevoke(): boolean {
        return this.selBehaviour == 'MassReleaseRevoke'
    }

    public isOPL(): boolean {
        return this.relrevokeParamsIn.HierarchyType == 'OPL'
    }
    public getLabelFromId(id): string {
        return this.filteredPeriod.find(x => x.id == id)?.label || id
    }
    public toolTipText(): string {
        if (this.isOPL()) {
            return 'Period is only selectable for Actual';
        }
        return this.selectedValues.length > 0 ? "Selected Period:" + this.selectedValues.toString() : 'No periods selected';
    }



}